export enum ERIFormTabs {
    main = 'main',
    changes = 'changes',
}

export enum ERIFormTabTitles {
    main = 'Основная информация',
    changes = 'Журнал изменений'
}
